/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Quick_LinksInputs */

const en_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quick-links`)
};

const ar_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روابط سريعة`)
};

const bn_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কুইক-লিংক`)
};

const de_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quicklinks`)
};

const es_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`enlaces rápidos`)
};

const fr_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`liens rapides`)
};

const pt_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`links rápidos`)
};

const zh_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速链接`)
};

const tr_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hızlı bağlantılar`)
};

const ru_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`быстрых ссылок`)
};

const pl_footer_quick_links = /** @type {(inputs: Footer_Quick_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`szybkie linki`)
};

/**
* | output |
* | --- |
* | "quick-links" |
*
* @param {Footer_Quick_LinksInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_quick_links = /** @type {((inputs?: Footer_Quick_LinksInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Quick_LinksInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_footer_quick_links(inputs)
	if (locale === "bn") return bn_footer_quick_links(inputs)
	if (locale === "de") return de_footer_quick_links(inputs)
	if (locale === "es") return es_footer_quick_links(inputs)
	if (locale === "fr") return fr_footer_quick_links(inputs)
	if (locale === "pt") return pt_footer_quick_links(inputs)
	if (locale === "zh") return zh_footer_quick_links(inputs)
	if (locale === "tr") return tr_footer_quick_links(inputs)
	if (locale === "ru") return ru_footer_quick_links(inputs)
	if (locale === "pl") return pl_footer_quick_links(inputs)
	return en_footer_quick_links(inputs)
});